<app-tab>
  <dx-data-grid
    id="TicketsGridContainer"
    [dataSource]="ds"
    [libGridDefault]="{stateStorageKey: 'app-tickets-grid'}"
    [libGridTitle]="{text: 'Mes demandes d\'assistance'}"
    (onEditingStart)="onEditingStart($event)"
    (onInitNewRow)="onInitNewRow($event)"
    (onRowInserting)="onRowInserting($event)"
    >
    <dxi-column
      caption="Numéro de ticket"
      dataType="string"
      dataField="name">
    </dxi-column>

    <dxi-column
      caption="Sujet"
      dataType="string"
      labelMode="floating"
      dataField="subject">
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      caption="Description"
      dataType="string"
      dataField="description"
      [visible]="false"
      >
      <dxo-form-item
        [colSpan]="2"
        editorType="dxTextArea"
        [editorOptions]="{ height: 100 }"
      >
      </dxo-form-item>
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      caption="État"
      dataType="string"
      dataField="status"
      cellTemplate="statusTemplate"
      >
      <div *dxTemplate="let data of 'statusTemplate'">
        <span class="ticketStatusLabel" [ngStyle]="{'backgroundColor':status_list[data.text]?.color}">{{status_list[data.text]?.name}}</span>
      </div>
    </dxi-column>

    <dxi-column
      caption="Créé par (Email)"
      dataType="string"
      dataField="raised_by">
    </dxi-column>

    <dxi-column
      caption="Date de création"
      dataType="string"
      dataField="opening_date">
    </dxi-column>

    <dxi-column
    type="buttons"
    [width]="110"
    caption="Actions"
    >
      <dxi-button
        text="Voir detail"
        [onClick]="showTicket"></dxi-button>
    </dxi-column>

    <dxo-editing
      mode="popup"
      [allowAdding]="canAdd"
      >
      <dxo-texts
      saveRowChanges="Soumettre">
        </dxo-texts>
      <dxo-popup title="Créer une demande d'assistance" [showTitle]="true" [onShowing]="editPopup" width="50%"></dxo-popup>
      <dxo-form [colCount]="1" [showValidationSummary]="true" labelLocation="top">
        <dxi-item dataField="subject"></dxi-item>
        <dxi-item dataField="description"></dxi-item>
        <dxi-item dataField="attachment"></dxi-item>

      </dxo-form>

    </dxo-editing>

    <dxi-column
        caption="Capture d'écran"
        dataField="attachment"
        [visible]="false"
        [showInColumnChooser]="false"
        editCellTemplate="uploadTemplate">
        <div *dxTemplate="let cellInfo of 'uploadTemplate'">
          <dx-file-uploader
            [multiple]="false"
            [allowCanceling]="true"
            name="attachment"
            accept="image/!*"
            uploadMode="useForm"
            (onValueChanged)="onUpload($event)"
          ></dx-file-uploader>
        </div>
    </dxi-column>

    <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>
    <dxo-group-panel [visible]="false"></dxo-group-panel>
    <dxo-export [enabled]="true" fileName="liste-tickets"
                [allowExportSelectedData]="true"></dxo-export>
    <dxo-sorting mode="multiple"></dxo-sorting>
    <dxo-paging [pageSize]="25"></dxo-paging>
    <dxo-pager
      [showPageSizeSelector]="true"
      [allowedPageSizes]="[25, 50, 100]"
      [showInfo]="true">
    </dxo-pager>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-search-panel
      [visible]="true"
      [width]="240"></dxo-search-panel>
    <dxo-header-filter [visible]="true"></dxo-header-filter>
  </dx-data-grid>

  <dx-popup
    [width]="800"
    height="90%"
    [title]="'Ticket: ' + ticket?.name"
    [showTitle]="true"
    [(visible)]="isTicketDetailVisible"
    (onContentReady)="onPopupContentReady($event)"
    contentTemplate="popupContent">
    <div *dxTemplate="let data of 'popupContent'">
      <dx-box direction="col" width="100%" height="100%">
        <dxi-item class="meta-bar" baseSize="auto" [ratio]="0" >
          <dx-box direction="row" crossAlign="center" width="100%" height="100%">
            <dxi-item class="meta-item" [ratio]="0" baseSize="auto">
              <span class="meta-item-label">Numéro de ticket</span>
              <span class="meta-item-value">{{ticket.name}}</span>
            </dxi-item>
            <dxi-item class="meta-item" [ratio]="0" baseSize="auto">
              <span class="meta-item-label">Date d'ouverture</span>
              <span class="meta-item-value">{{ticket.opening_date+" "+ticket.opening_time  | date:'yyyy-MM-dd HH:mm'}}</span>
            </dxi-item>
            <dxi-item class="meta-item" [ratio]="0" baseSize="auto">
              <span class="meta-item-label">Status</span>
              <span class="meta-item-value"><span class="ticketStatusLabel" [ngStyle]="{'backgroundColor':status_list[ticket.status].color}">{{status_list[ticket.status].name}}</span></span>
            </dxi-item>
            <dxi-item class="meta-item" [ratio]="0" *ngIf="ticket.priority" baseSize="auto">
              <span class="meta-item-label">Priorité</span>
              <span class="meta-item-value">{{ticket.priority}}</span>
            </dxi-item>
            <dxi-item class="meta-item" [ratio]="0" *ngIf="ticket.issue_type" baseSize="auto">
              <span class="meta-item-label">Type</span>
              <span class="meta-item-value">{{ticket.issue_type}}</span>
            </dxi-item>
            <dxi-item [ratio]="1"></dxi-item>
            <dxi-item [ratio]="0" baseSize="auto">
              <dx-button
              [disabled]="ticket.status != 'Closed' && ticketOwner ? null : 'disabled'"
                stylingMode="contained"
                text="Clore le ticket"
                type="default"
                width="auto"
                (onClick)="closeTicket(ticket)">
              </dx-button>
            </dxi-item>

          </dx-box>

        </dxi-item>
        <dxi-item class="content" [ratio]="2">
          <dx-scroll-view
          #scrollView
          id="scrollview"

        >
          <h2 class="title">
            {{ticket.subject}}
          </h2>

          <div class="message">
            <div  [innerHTML]="ticket.description"></div>
          </div>

          <div class="resolution" *ngIf="ticket.resolution_details">
            <h5>Résolution</h5>
            <div  [innerHTML]="ticket.resolution_details"></div>
            <br>
            <dx-button
              *ngIf="ticket.status != 'Closed'  && ticketOwner"
              stylingMode="outlined"
              text="Approuver la solution"
              type="default"
              width="auto"
              (onClick)="closeTicket(ticket)">
            </dx-button>
            <div class="date">{{ticket.resolution_date  | date:'yyyy-MM-dd HH:mm'}}</div>
          </div>

            <h5 *ngIf="ticket.comments?.length > 0" class="comment-box-title">Commentaires</h5>

            <ul class="ticketCommentsList" *ngIf="ticket.comments?.length > 0">
              <li class="ticketComment" *ngFor="let comment of ticket.comments">
                <ng-container
                  *ngIf="comment.comment_type == 'Attachment' then attachmentTemplate; else commentTemplate">
                </ng-container>
                <ng-template #attachmentTemplate>
                  <div class="ticketCommentHead">Capture d'écran <span class="date">{{comment.creation  | date:'yyyy-MM-dd HH:mm'}}</span></div>
                  <div class="ticketCommentContent">
                    <a href="{{comment.content}}" target="_blank">
                      <img src="{{comment.content}}" alt="" width="150" height="150">
                    </a>
                  </div>
                </ng-template>
                <ng-template #commentTemplate>
                  <div class="ticketCommentHead">{{comment.comment_by}} <span class="date">{{comment.creation  | date:'yyyy-MM-dd HH:mm'}}</span></div>
                  <div class="ticketCommentContent">
                    <span  [innerHTML]="comment.content"></span>
                  </div>
                </ng-template>




              </li>
            </ul>
          </dx-scroll-view>

          <div class="reply-box" *ngIf="ticket.status != 'Closed'">
            <dx-text-area
              [height]="50"
              valueChangeEvent="keyup"
              [value]="newCommentContent"
              placeholder="Envoyer un message"
              (onValueChanged)="onCommentValueChanged($event)"
            >
            </dx-text-area>
            <dx-button
              stylingMode="contained"
              text="Envoyer"
              type="default"

              [disabled]="newCommentButtonDisabled"
              width="auto"
              (onClick)="addComment(ticket,newCommentContent)">
            </dx-button>
          </div>

        </dxi-item>



      </dx-box>
    </div>
  </dx-popup>
</app-tab>
